import React from "react";

const DigitalGrowthSection = () => {
  return (
    <div className="text-center px-4 sm:px-10 md:px-16 lg:px-28">
      <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-bold  mt-6 sm:mt-10 lg:mt-6 text-[#0D283F]">
        Your Trusted Digital Growth Partner
      </h2>

      <div className="mb-10 sm:mb-12 max-w-7xl mx-auto px-4 sm:px-6">
        <p className="text-sm sm:text-base md:text-lg lg:text-md text-center leading-relaxed mt-4 sm:mt-8 lg:mt-4 text-black">
          We offer a comprehensive range of services designed to drive business success and foster innovation. With a focus on AI-powered solutions, we help businesses optimize their operations, enhance customer engagement, and achieve sustainable growth. Our expertise spans across digital marketing, web and app development, staffing, SMS services, and API integration.
        </p>
      </div>
    </div>
  );
};

export default DigitalGrowthSection;
